import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";
import { Empty, Spin } from "antd";

const PosGroupColumnChart = (props) => {
  var datam = [];
  if (props.data) {
    datam = props.data.map((item) => {
      const transactionDate = new Date(item.transactionDate);
      const day = transactionDate.getDate().toString().padStart(2, "0");
      const month = (transactionDate.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const formattedDate = `${day}.${month}`;

      return {
        name: item.bankName,
        value: item.netAmount,
        date: formattedDate,
      };
    });
  }

  if (props.isLoading) {
    return (
      <div style={{ textAlign: "center", position: "relative" }}>
        <Spin size="small" />
      </div>
    );
  }

  if (datam.length === 0) {
    return <Empty description="Veri Yok" />;
  }

  const config = {
    data: datam,
    isGroup: true,
    xField: "date",
    yField: "value",
    seriesField: "name",
    xAxis: {
      title: {
        text: "Tarih",
      },
    },
    yAxis: {
      title: {
        text: "İşlem Tutarı",
      },
      label: {
        formatter: (v) => {
          let formattedValue = "";

          if (v >= 1e6) {
            formattedValue = `${(v / 1e6).toFixed(1)} M`;
          } else if (v >= 1e3) {
            formattedValue = `${(v / 1e3).toFixed(1)} K`;
          } else {
            formattedValue = new Intl.NumberFormat("tr-TR", {
              style: "currency",
              currency: "TRY",
              minimumFractionDigits: 2,
            }).format(v);
          }
          return formattedValue;
        },
      },
      min: 0,
    },
    // label: {
    //   position: "middle",
    //   layout: [
    //     {
    //       type: "interval-adjust-position",
    //     },
    //     {
    //       type: "interval-hide-overlap",
    //     },
    //     {
    //       type: "adjust-color",
    //     },
    //   ],
    //   formatter: (v) => {
    //     console.log("v", v);
    //     let formattedValue = "";

    //     if (v >= 1e6) {
    //       formattedValue = `${(v / 1e6).toFixed(1)} M TL`;
    //     } else if (v >= 1e3) {
    //       formattedValue = `${(v / 1e3).toFixed(1)} K TL`;
    //     } else {
    //       formattedValue = `${new Intl.NumberFormat("tr-TR", {
    //         currency: "TRY",
    //         minimumFractionDigits: 2,
    //       }).format(v.value)} TL`;
    //     }
    //     return formattedValue;
    //   },
    // },
    tooltip: {
      customContent: (title, data) => {
        const content = data
          .map((item) => {
            const formattedValue = new Intl.NumberFormat("tr-TR", {
              currency: "TRY",
              minimumFractionDigits: 2,
            }).format(item.value);

            return `
            
            <div style="margin-bottom: 10px;" >
                <span style="font-weight: bold; color: ${item.color}; margin-right: 8px;">●</span>
                <span>${item.name} :</span>
                <span style="float: right; margin-left: 10px; text-align: right;">${formattedValue} TL</span>
              </div>
            `;
          })
          .join("");

        return `
        <div style="margin-top: 10px;">${title}</div>
        <div style="margin-top: 20px; margin-bottom: 15px;">${content}</div>
        `;
      },
    },
  };
  return <Column {...config} />;
};
export default PosGroupColumnChart;
